import React from "react";

export function Logo({ width = 200, height }: any) {
  return <img src={require("../images/logo.png")} width={width} height={height} alt="winfacil-logo" />
}
